import { toast } from "@appsmith/ads";
import { refreshLicenseAfterCheckout } from "ee/actions/billingActions";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import getQueryParamsObject from "utils/getQueryParamsObject";

export const useRefreshLicense = () => {
  const { message, payment } = getQueryParamsObject();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const refreshLicenseAfterSuccess = useCallback(
    (redirectUrl: string) => {
      if (payment === "success" && message) {
        setIsLoading(true);
        toast.show(message, {
          kind: "success",
        });
        dispatch(refreshLicenseAfterCheckout(redirectUrl));
      } else {
        setIsLoading(false);
      }
    },
    [payment, message],
  );

  return {
    isLoading,
    refreshLicenseAfterSuccess,
  };
};
